class DiscountAppointmentPopup {
    constructor(element) {
        this.discountAppointmentTimeOut = new DiscountAppointmentTimeOut()

        if (this.discountAppointmentTimeOut.isInTimeOut) {
            localStorage.removeItem('haveDiscountPopup')
            return
        }

        this.element = element
        this.discountOpenButton = $('.js-discount-open-button')
        this.timer = $(this.element).find('.js-discount-appointment-timer')
        this.form = $(this.element).find('.js-form')
        this.activityDetector = null

        this.pointStorage = new PointsStorage()
        this.discountAppointmentTimer = new DiscountAppointmentTimer(this.timer)

        this.init()
        this.initListeners()
    }

    init() {
        if (!localStorage.getItem('haveDiscountPopup')) {
            this.activityDetector = new ActivityDetector()
        } else {
            this.discountAppointmentTimer.start()
            this.discountOpenButton.show()
        }
    }

    initListeners() {
        $(this.timer).on('timer:end', this.onTimerEnd.bind(this))
        $(window).on('user:inactive', this.onUserInactive.bind(this))
        $(this.form).on('form:success', this.onFormSuccess.bind(this))
    }

    onTimerEnd() {
        this.discountAppointmentTimeOut.setTimeOutByHour(2)
        localStorage.removeItem('haveDiscountPopup')
        this.discountAppointmentTimer.clear()
        this.discountOpenButton.hide()
        this.pointStorage.resetPoints()
    }

    onUserInactive() {
        this.discountAppointmentTimer.start()
        localStorage.setItem('haveDiscountPopup', '1')
        this.discountOpenButton.show()
        this.discountOpenButton.click()
        this.activityDetector?.removeActivityListeners()
    }

    onFormSuccess() {
        localStorage.removeItem('haveDiscountPopup')
        this.discountOpenButton.hide();
        this.discountAppointmentTimeOut.setTimeOutByDay(7)
        this.discountAppointmentTimer.clear()
    }
}

const popup = $('.js-discount-popup')

if (popup.length) {
    new DiscountAppointmentPopup(popup[0])
} else {
    localStorage.removeItem('activityPoints')
    localStorage.removeItem('endTime')
    localStorage.removeItem('haveDiscountPopup')
}
